import { SparklingFillIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { Colors } from '@zep/ui-tokens';
import S from '../SubscriptionPayment.module.scss';
export const PlanTitle = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className={S.title} data-sentry-component="PlanTitle" data-sentry-source-file="PlanTitle.tsx">
      <SparklingFillIcon width={22} height={22} fill={Colors.Gray700} data-sentry-element="SparklingFillIcon" data-sentry-source-file="PlanTitle.tsx" />
      {t('subscription:payment.title')}
    </div>;
};